export default __webpack_public_path__ + "static/media/Reconstruccion.fa678844.png";